// extracted by mini-css-extract-plugin
module.exports =  {"switch":"_0d624b9a27--switch--CQEnX","indicator":"_0d624b9a27--indicator--kueqN","label":"_0d624b9a27--label--hfzMb"};